import KeywordFilter from "components/filters/Filters/KeywordFilter";
import OnlyMySelectionFilter from "components/filters/Filters/OnlyMySelectionFilter";
import { ClientFileSortFilter } from "components/filters/Filters/SortFilter";
import VisibilityFilter from "components/filters/Filters/VisibilityFilter";
import ListTemplate from "components/ListTemplate";
import SmallDetails from "components/SmallDetails/SmallDetails";
import { BatchDeleteModal } from "components/Tables/MySelection/Modals";
import ChangeVisibleToExternalModal from "components/Tables/MySelection/Modals/ChangeVisibleToExternalModal";
import ClientFileDownloadAll from "components/Tables/MySelection/Modals/ClientFileDownloadAll";
import VisibleToExternalIcon from "components/VisibleToExternal/VisibleToExternalIcon";
import React from "react";
import { formatShortDate } from "utilities";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { useLoaderData } from "react-router";

const FileOverviewListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.FileOverviewListFrontModel>();

  return <ListTemplate
    title={viewModel.pageTitle}
    filterSet="allFiles_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={window.CoreApi.File.Paginated}
    getId={item => item.id}
    onDelete={item => window.CoreApi.File.DeleteClientFile(item.id)}
    layout={{
      type: "table",
      columns: [{
        key: "name",
        header: RESX.GeneralLabels.Name,
        render: item => <SmallDetails
          label={item.fullName}
          link={item.downloadUrl}
          subLabel={item.uploadBy}
        />,
        size: "1fr"
      }, {
        key: "uploadedOn",
        header: RESX.File.UploadedOn,
        render: item => formatShortDate(item.uploadOnUtc),
      }, {
        key: "linkedTo",
        header: RESX.GeneralLabels.LinkedTo,
        render: item => <SmallDetails
          label={item.parent.description}
          link={item.parent.detailUrl}
          subLabel={site.currentEnvironment[item.parent.objectType].singular}
        />,
        size: "1fr",
      }, {
        key: "size",
        header: RESX.File.Size,
        render: item => item.contentLengthText,
        className: "s1_cell_financialamount",
      }, {
        key: "visibleToExternal",
        header: "",
        render: item => <div style={{ padding: 5 }}>
          <VisibleToExternalIcon visibleToExternal={item.visibleToExternal} />
        </div>,
        size: "30px"
      }]
    }}
    filters={<>
      <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
      <VisibilityFilter
        title={RESX.GeneralLabels.VisibleToExternalUsers}
        onlyVisibleLabel={RESX.GeneralLabels.VisibleToExternalUsers}
        onlyNotVisibleLabel={RESX.GeneralLabels.NotVisibleToExternalUsers}
      />
      <ClientFileSortFilter />
      <OnlyMySelectionFilter />
    </>}
    functions={{
      mapResponseToFilterValues,
      mapFilterValuesToInstruction,
    }}
    options={{
      mySelection: {
        isSelected: item => item.isSelected,
        mainArea: "clientFile",
        batchActions: [{
          label: RESX.Buttons.btnDeleteAll,
          modal: BatchDeleteModal,
        }, {
          label: RESX.GeneralLabels.VisibleToExternalUsers,
          modal: ChangeVisibleToExternalModal,
        }, {
          label: RESX.File.DownloadAll,
          modal: ClientFileDownloadAll,
        }],
      }
    }}
  />
};

export default FileOverviewListApp;